import React from 'react';
import InputRange from 'react-input-range';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';

export default class Children extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      active: false,
      pristine: true,
      age: [],
      default_age: 7,
      max_count: 8,
      min_age: 0,
      max_age: 17
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    if (
      typeof nextProps.children_ages != 'undefined' &&
      nextProps.children_ages.length > 0 &&
      this.state.pristine
    ) {
      const age = nextProps.children_ages.split(',');
      this.setState({ age, value: age.length, pristine: false });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => (
    <div
      className={
        'children select-wrapper animated-text-form extended ' +
        (this.state.active ? 'active' : '')
      }
      ref={() => {
        this.returnSearchedValue = this.returnSearchedValue.bind(this);
      }}
    >
      <label className="animated-text-label" htmlFor="children-input">
        {' '}
        <span className="animated-text-label-name">
          {this.props.title}
        </span>{' '}
      </label>
      <i className="dropdown-icon fa fa-chevron-down" />
      <input
        id="children-input"
        type="text"
        value={this.formatedValue()}
        className="animated-text-input"
        placeholder=""
        readOnly
        onChange={this.handleChange}
        onFocus={this.handleFocus}
      />
      <div className="dropdown-menu">
        <div className="reset-filter-custom mobile">
          <span onClick={this.handleReset} className="reset">
            <span> {T('clear')} </span>
          </span>
          <span onClick={this.handleClose} className="confirm">
            <span> {T('choose')} </span>
          </span>
        </div>
        <i className="fa fa-times close-icon" onClick={this.handleClose} />
        <div className="dropdown-header">
          <span> {T('children_number')} </span>
        </div>
        <div className="dropdown-wrapper children-number number-picker">
          <span
            className="subtraction"
            onClick={this.handleAmountChange.bind(this, '-')}
          >
            <span className="action-element">-</span>
          </span>
          <span className="result"> {this.state.value} </span>
          <span
            className="addition"
            onClick={this.handleAmountChange.bind(this, '+')}
          >
            <span className="action-element">+</span>
          </span>
        </div>
        {this.renderSliders()}
        <div className="reset-filter desktop">
          <span onClick={this.handleReset} className="reset">
            <i className="fa fa-times reset-icon" />
            <span> {T('clear')} </span>
          </span>
          <span onClick={this.handleClose} className="confirm">
            <span> {T('choose')} </span>
          </span>
        </div>
      </div>
    </div>
  );

  stopEventBehaviour(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
      this.stopEventBehaviour(event);
    }
  };

  handleChange = event => this.setState({ value: event.target.value });

  handleFocus = () => {
    this.setState({ active: true });
  };

  handleClose = () => {
    this.setState({ active: false });
  };

  handleReset = () => {
    this.setState({ age: [], value: 0 });
  };

  formatedValue = () => (this.state.value == 0 ? '' : this.state.value);

  childrenAge = i => {
    return this.state.age[i] != undefined && this.state.age[i] != null
      ? this.state.age[i]
      : this.state.default_age;
  };

  handleRangeChange(index, value) {
    let age = this.state.age;
    age[index] = value;
    this.setState({ age });
  }

  handleAmountChange = action => {
    let value = this.state.value;
    if (action == '+' && this.state.value < this.state.max_count) {
      this.handleRangeChange(value, this.state.default_age);
      ++value;
    }
    if (action == '-' && this.state.value > 0) {
      --value;
    }
    this.setState({ value });
  };

  renderSliders = () => {
    let childrenCount = this.state.value;
    let children = this.state;

    return (
      <div
        className={
          'children-age-wrapper' + (childrenCount === 0 ? '' : ' active')
        }
      >
        <div className="dropdown-header">
          <span> {T('children_age')} </span>
        </div>
        <ul className="dropdown-wrapper children-sliders">
          {Array.apply(null, Array(parseInt(childrenCount))).map((v, i) => {
            return (
              <li
                className="item"
                key={i}
                style={{ width: '175px', marginTop: '25px' }}
              >
                <span className="custom-label min">{children.min_age}</span>
                <InputRange
                  id={'child-range-' + i}
                  formatLabel={value => `${value}`}
                  minValue={children.min_age}
                  maxValue={children.max_age}
                  value={this.childrenAge(i)}
                  onChange={this.handleRangeChange.bind(this, i)}
                />
                <span className="custom-label max">{children.max_age}</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  returnSearchedValue = () =>
    this.state.age.length ? this.state.age.slice(0, this.state.value) : false;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/children.js